export * from './icons.js';
//# sourceMappingURL=index.js.map